module.exports = __webpack_public_path__ + "img/governance-bannner5.87b65ff5.png";